import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {SalesAreaSearch} from "./SalesAreaSearch";

const vUI_SalesOrg_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB SalesOrg Id', columnResourceName: 'colwbId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org ID', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    ENTERPRISE_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set',
            columnResourceName: 'colMasterDataSet',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    SOURCE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Key Set', columnResourceName: 'colSource', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.saptimestamp,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM/dd/yyyy"
        },
        domainOptions: {}
    },
    REPORTING_LEVERS_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Reporting Levers',
            columnResourceName: 'colReportingLevers',
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Master Data Set WB Id',
            columnResourceName: 'colMDSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    MDSET_ID:                 {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set',
            columnResourceName: 'colMDSetName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Company',
            columnResourceName: 'colCompanyId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    COMPANY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company Id', columnResourceName: 'colCompanyId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    COMPANY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company', columnResourceName: 'colCompanyName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    ALL_SALES_AREAS: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Sales Area',   columnResourceName: 'colUsrGrpSalesArea',      alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 256}
    },
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Sales Area ID',  columnResourceName: 'colSARWBId',      alignment: HorizAlignment.Center},
        domainOptions: { maxLength: 256,  search: SalesAreaSearch, profileId: "default", searchCondition: {}}
    },

};

const SalesOrgSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_SALESORG_ID',
        id_ui: 'SALESORG_ID',
        name: 'SALESORG_NAME'
    },

    searchProviderFields: vUI_SalesOrg_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                if(_.isUndefined(searchRequestSubset.where['WB_SALESORG_ID']))
                    searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_SalesOrg_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_SALESORG_ID)
                    resolve(returnVals)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset = {where: {'WB_SALESORG_ID': {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}}}
            }
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_SalesOrg_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const SalesOrgSearchProviderBenchmark: ISearchProvider = {

    keyFields: {
        id: 'WB_SALESORG_ID',
        id_ui: 'SALESORG_ID',
        name: 'SALESORG_NAME'
    },

    searchProviderFields: vUI_SalesOrg_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                if(_.isUndefined(searchRequestSubset.where['WB_SALESORG_ID']))
                    searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_SalesOrg_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_SALESORG_ID)
                    resolve(returnVals)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
                let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                let searchRequestSubset: { where?: { [id: string]: any } } = {}
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    searchRequestSubset = {
                        where: {'WB_SALESORG_ID': {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}}
                    }
                }
                let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                    'vUI_SalesOrg_Search',
                    this.searchProviderFields,
                    [fieldName])


                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(_.map(res, (aRow) => {
                            return aRow[fieldName]
                        }))
                    })
                    .catch((err) => {
                        error(err)
                    })
            }
        )
    }
};

const SalesOrgSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SalesOrgSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Sales Org ID', searchProviderFieldId: 'SALESORG_ID', renderOptions: {}},
        {profileFilterName: 'Sales Org Name', searchProviderFieldId: 'SALESORG_NAME', renderOptions: {}},
        {profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Company', searchProviderFieldId: 'COMPANY_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Sales Area',  searchProviderFieldId: 'WB_SALESAREA_ID',    bMultiSelect: true, renderOptions: { }}
    ],
    profileDisplayFields: [
        'SALESORG_ID', 'SALESORG_NAME', 'MDSET_NAME', 'COMPANY_NAME', 'ALL_SALES_AREAS', 'SOURCE'
    ],

    profileSearchProvider: SalesOrgSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SalesOrgSearchProfileBenchmark: ISearchProfile = {
    profileId: "benchmark",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SalesOrgSearchProviderBenchmark"},

    profileFilter: [
        {profileFilterName: 'Sales Org ID', searchProviderFieldId: 'SALESORG_ID', renderOptions: {}},
        {profileFilterName: 'Sales Org Name', searchProviderFieldId: 'SALESORG_NAME', renderOptions: {}}
    ],
    profileDisplayFields: [
        'SALESORG_ID', 'SALESORG_NAME', 'MODIFIED_DTTS', 'REPORTING_LEVERS_COUNT'
    ],

    profileSearchProvider: SalesOrgSearchProviderBenchmark,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SalesOrgSearch: ISearch = {
    searchName: "Find SalesOrg",
    renderOptions: {ui5ResourceId: "SalesOrgSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SalesOrgSearchProfileByName, SalesOrgSearchProfileBenchmark]
};
PAEnvironment.registerBusinessObjectSearch("SalesOrgBO", "SalesOrg", SalesOrgSearch, "Sales Org Search")

export {SalesOrgSearch}